export const getShadowStyles = shadow => {
  if (!shadow || !shadow.enabled) {
    return null
  }

  let styles = {
    shadowColor: shadow.color,
    shadowOffset: { width: shadow.x || 0, height: shadow.y || 0 },
    shadowOpacity: 1,
    shadowRadius: shadow.size || 0,
  }

  // TODO: Fix this by adding proper android shadows
  // if (Platform.OS === 'android') {
  //   styles.elevation = 1
  // }

  return styles
}
